<app-dialog
    [showHeader]="true"
    [header]="header"
    [minWidth]="640"
    [show]="true"
    [hasControls]="true"
    [hideControlsDivider]="true"
    [saveBtnText]="submitButtonText"
    [disableSaveBtn]="form.invalid || (loading$ | async)"
    [formGroup]="form"
    (save)="submit()"
    (cancel)="cancel.emit()"
>
    <div>
        <app-input
            class=""
            formControlName="name"
            [showErrors]="true"
            [autofocus]="true"
            label="Location name"
            [maxLength]="30"
            [symbolsLeftCounter]="true"
            errorMessage="Location already exists"
            #nameInput
        ></app-input>
    </div>
   <div class="mt-5">
        <app-textarea label="Description" 
            formControlName="description"
            [optional]="true"
            [maxLength]="100"
            [symbolsLeftCounter]="true"
        >
        </app-textarea>
    </div>


</app-dialog>